import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Currency } from '../../models/brand/currency.model';

@Injectable({
    providedIn: 'root',
})
export class CurrencyService {
    constructor(private readonly http: HttpClient) {}

    getCurrencies(): Observable<Currency[]> {
        return this.http.get<Currency[]>(environment.url + `/api/Currency`);
    }
}
